<mat-card class="login-card">
  <mat-card-header class="mat-card-header">
    DMX3-Wetterportal
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <h2>Anmelden</h2>
      <mat-form-field appearance="outline">
        <mat-label>E-Mail</mat-label>
        <span matPrefix>
          <mat-icon color="accent" style="margin-right: 10px;">perm_identity</mat-icon>
        </span>
        <input matInput type="email" placeholder="Email" formControlName="username" required>
        <mat-error>
          Bitte geben Sie eine valide E-Mail Addresse ein
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Passwort</mat-label>
        <span matPrefix>
          <mat-icon color="accent" style="margin-right: 10px;">password</mat-icon>
        </span>
        <input matInput [type]="hidePasswordField ? 'password' : 'text'" placeholder="Passwort"
               formControlName="password" required>
        <mat-icon class="visibility-icon" matSuffix
                  (click)="hidePasswordField = !hidePasswordField">{{hidePasswordField ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-error>
          Bitte geben Sie ein Passwort ein
        </mat-error>
      </mat-form-field>
      <button mat-raised-button class="login-button" color="primary">
        <span *ngIf="!isLoggingIn">Login</span>
        <mat-icon *ngIf="isLoggingIn">
          <mat-spinner color="accent" diameter="20"></mat-spinner>
        </mat-icon>
      </button>
      <!--        <mat-checkbox [(ngModel)]="saveLoginChecked"-->
      <!--                      (ngModelChange)="saveLoginChecked = $event"-->
      <!--                      [checked]="saveLoginChecked" class="save_login_checkbox"-->
      <!--                      [ngModelOptions]="{standalone: true}"-->
      <!--                      labelPosition="after">Angemeldet bleiben-->
      <!--        </mat-checkbox>-->
    </form>
  </mat-card-content>
</mat-card>
